export enum IntegrationVendor {
    D365_BC = 'D365_BC',
    /**
     * Bexio is a per-company integration (different scope + provider than the
     * per-org vendors). It lives in the catalog so it can render in the same
     * unified card grid, but its connection state + connect flow are owned by
     * aumico-lib-companies-fe, NOT by this lib. It is NEVER a ConnectionMapping
     * vendor (see ConnectionMappingVendor).
     */
    BEXIO = 'BEXIO',
    /**
     * Abacus FIBU. Per-org integration like D365 BC: one IntegrationConnection
     * per (org, serverUrl). The per-company link is a ConnectionMapping whose
     * `externalCompanyId` is the Abacus Mandanten ID (user typed, not auto
     * enumerable). Auth is OAuth2 Client Credentials but without a Microsoft
     * style popup — the user provides serverUrl, clientId, clientSecret in a
     * plain form and the BE runs OIDC discovery + token + smoke test in one
     * synchronous call.
     */
    ABACUS = 'ABACUS',
    /**
     * Topal. Per-org integration like D365 BC / Abacus: one IntegrationConnection
     * per (org, serverUrl). Topal's REST API runs on-premise on the customer's own
     * machine (typically `https://<host>:9001/api/v1`); the user provides serverUrl +
     * username + password in a plain form and the BE mints a Bearer token via the
     * password grant + a smoke test in one synchronous call. Company mapping uses the
     * auto-match flow (Topal exposes `GET /clients`), like D365 BC.
     */
    TOPAL = 'TOPAL',
    /**
     * Accounto (Public API v2, cloud). Per-org integration like Topal: one IntegrationConnection
     * per (org, Accounto tenant). The user pastes ONE API key (a JWT the BE reads `tenant_id` and
     * `exp` from); there is no server URL (the BE's config holds it) and no OAuth. A Treuhand key
     * lists all client tenants, a KMU key exactly its own; both auto-match by tenant name.
     * The key cannot be refreshed — the card warns before `tokenExpiresAt` (REV-21119 D7).
     */
    ACCOUNTO = 'ACCOUNTO',
    /**
     * Proffix (PxRestAPI). Per-org integration like Topal: one IntegrationConnection
     * per (org, serverUrl origin). The PxRestAPI runs on the customer's own server
     * (`https://<host>:<port>/pxapi/V4`); the user provides serverUrl + REST-API password
     * + username + password in a plain form. The BE opens a Proffix session per sync
     * (login → read → logout), so no live session is ever stored. Company mapping uses
     * the auto-match flow (`PRO/Datenbank` lists the Mandanten), like Topal.
     */
    PROFFIX = 'PROFFIX',
    /**
     * SharePoint / Microsoft 365 — a DOCUMENT source, not an accounting vendor: it has
     * no journal import and no ConnectionMapping (see ConnectionMappingVendor). It is a
     * per-org integration all the same: the BE mints the connection from the calling
     * user's organization (`GET integrations/sharepoint/connect` is @Roles(ORG_ADMIN)
     * and its DTO carries only an optional displayName), so it belongs in the Org
     * Settings card grid next to the accounting vendors.
     *
     * The per-CLOSING folder bindings (`/projects/:id/sharepoint-folders`) are the
     * downstream usage of this org connection — the rough equivalent of a per-company
     * mapping — and keep their own `sharepoint` sub-slice of IntegrationState.
     */
    SHAREPOINT = 'SHAREPOINT',
}
